import { render, staticRenderFns } from "./IncomingChannelList.vue?vue&type=template&id=6c9bc8fa&scoped=true&"
import script from "./IncomingChannelList.vue?vue&type=script&lang=js&"
export * from "./IncomingChannelList.vue?vue&type=script&lang=js&"
import style0 from "./IncomingChannelList.vue?vue&type=style&index=0&id=6c9bc8fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9bc8fa",
  null
  
)

export default component.exports